import React from 'react';
import { Box, Grid, Avatar, Typography } from '@mui/material';

/**
 * Simple thumbnail gallery picker.
 * Props:
 * - images: array of URL strings
 * - value: currently selected URL
 * - onChange(url): callback when user picks
 */
const ImagePicker = ({ images = [], value, onChange }) => {
  const handleSelect = (url) => {
    if (onChange) onChange(url);
  };

  return (
    <Grid container spacing={2} sx={{ maxHeight: 300, overflowY: 'auto' }}>
      {images.map((url) => {
        const selected = value === url;
        return (
          <Grid item xs={3} sm={2} key={url}>
            <Box
              onClick={() => handleSelect(url)}
              sx={{
                border: selected ? '2px solid' : '1px solid',
                borderColor: selected ? 'primary.main' : 'divider',
                borderRadius: 1,
                p: 0.5,
                cursor: 'pointer',
                position: 'relative',
              }}
            >
              <Avatar
                variant="rounded"
                src={url}
                alt="award"
                sx={{ width: '100%', height: 64, objectFit: 'cover' }}
              />
              {selected && (
                <Typography
                  variant="caption"
                  sx={{
                    position: 'absolute',
                    bottom: 2,
                    right: 2,
                    bgcolor: 'primary.main',
                    color: '#fff',
                    px: 0.5,
                    borderRadius: 0.5,
                  }}
                >
                  ✓
                </Typography>
              )}
            </Box>
          </Grid>
        );
      })}
      {images.length === 0 && (
        <Grid item xs={12}>
          <Typography variant="body2" color="text.secondary">
            No images found.
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default ImagePicker;
